import React, { useEffect, useState } from 'react'
import { composeId } from '../../utils'
import FormControl from '../form-control'
import Icon from '../icon'
import InputLabel from '../input-label'
import { Button, Container, Input, Flex } from './style'

export interface Props {
  'data-qa'?: string
  disabled?: boolean
  label?: string
  maxValue: number
  minValue: number
  onChange?: Function
  step?: number
  style?: object
  value: number
}

const NumericInput: React.FC<Props> = (props: Props) => {
  const id = composeId(props.label)
  const [value, setValue] = useState<number>(props.value)

  const addValue = (): void => {
    setValue(value + props.step)
  }
  const removeValue = (): void => {
    setValue(value - props.step)
  }

  useEffect(() => {
    if (props.onChange) props.onChange(value)
  }, [value])

  return (
    <FormControl data-qa={props['data-qa']}>
      {props.label && (
        <InputLabel
          htmlFor={id}
          text={props.label}
          data-qa={props['data-qa'] && `${props['data-qa']}-label`}
        />
      )}
      <Container style={props.style}>
        <Flex>
          <Button
            onClick={removeValue}
            disabled={value <= props.minValue || props.disabled}
            data-qa={props['data-qa'] && `${props['data-qa']}-remove`}
          >
            <Icon name="remove" size={26} />
          </Button>
          <Input
            className={`${props.disabled ? 'is-disabled' : ''}`}
            data-qa={props['data-qa'] && `${props['data-qa']}-input`}
          >
            {value}
          </Input>
          <Button
            onClick={addValue}
            disabled={value >= props.maxValue || props.disabled}
            data-qa={props['data-qa'] && `${props['data-qa']}-add`}
          >
            <Icon name="add" size={26} />
          </Button>
        </Flex>
      </Container>
    </FormControl>
  )
}

NumericInput.defaultProps = {
  step: 1,
  disabled: false,
}

export default NumericInput
